import React from "react";
import PropTypes from "prop-types";

import { HomeView } from "../menu/home/HomeView";
import { isAuthenticated, login } from "@seims/shared/src/security";

export const ToggleHomeView = () => (isAuthenticated() ? <HomeView /> : null);


export const handleLogin = async () => {
    login({
        redirectUri: `${window.location.origin}/events`
    });
};
